import { createAction, createReducer } from "@reduxjs/toolkit";

const UserData = createAction("UserData");
const OneUserData = createAction("OneUserData");
const BlogData = createAction("BlogData");

const initialState = {
  users: {},
  oneuser: {},
  blogdata: [],
};

export const responseReducer = createReducer(initialState, (builder) => {
  builder.addCase(UserData, (state, action) => {
    state.users = action.payload;
  });

  builder.addCase(OneUserData, (state, action) => {
    state.oneuser = action.payload;
  });

  builder.addCase(BlogData, (state, action) => {
    state.blogdata = action.payload;
  });
});
